module.exports = __webpack_public_path__ + "static/media/default_thumb_banner.f39457a3.png";